import { FiberPlanStatus, ProductFamily } from './types';

export function isFiberPresale(enableFiber: boolean, isFiber: boolean, planStatus: string) {
  return enableFiber && isFiber && planStatus === FiberPlanStatus.FIBER_PRESALE;
}

export function isFiber(planProductFamily: string) {
  return planProductFamily === ProductFamily.FIBER;
}

export function isFiberLive(enableFiber: boolean, isFiber: boolean, planStatus: string) {
  return enableFiber && isFiber && planStatus === FiberPlanStatus.FIBER_LIVE;
}
